<template>
  <div class="product">
    <div>
      <el-button
        type="success"
        size="mini"
        :disabled="selectedItems.length === 0"
        class="right"
        @click="assignToNewPo"
      >
        Assign to New PO
      </el-button>
      <el-table
        id="stock-table"
        :data="po_stock_items"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div class="padding-left">
              Link:
              <el-button
                type="text"
                @click="stock_item_link(scope.row.stock_item.id)"
              >
                Stock Item
              </el-button>
              <p>
                <span>Min Qty:</span>
                <label
                  id="lblMinQty"
                  class="calculation"
                >{{ format_number(scope.row.purchased_quantity) }}</label>
              </p>
              <p>
                <span>Unit Price Calculation:</span>
                <label
                  id="lblStockPrice"
                  class="calculation"
                >{{
                  scope.row.stock_item.price
                }}</label>
                <label
                  class="calculation"
                  v-html="stock_price_desc"
                />
              </p>
              <p>
                <span>Stock on hand:</span>
                <label class="calculation">{{ scope.row.stock_item_branch.stock_on_hand }}</label>
              </p>
              <p v-show="Boolean(po_id > 0)">
                <span>Allocated:</span>
                <label class="calculation">{{ scope.row.stock_item_branch.allocated }}</label>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="stock_item.category_supplier.name"
          label="Category"
        />
        <el-table-column
          prop="stock_item.name"
          label="Items"
        />
        <el-table-column
          label="Quantity"
        >
          <template slot-scope="scope">
            {{ format_number(scope.row.quantity) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Purchase Qty"
        >
          <template slot-scope="scope">
            {{ format_number(scope.row.purchased_quantity) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Purchase Price"
        >
          <template slot-scope="scope">
            {{ format_number(scope.row.unit_price) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Total Price"
        >
          <template slot-scope="scope">
            {{ format_number(scope.row.unit_price * scope.row.purchased_quantity) }}
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="open_edit_dialog(scope.row)"
            >
              Edit
            </el-button>
            <el-button
              type="danger"
              size="mini"
              @click="delete_stock_item_from_purchase_order(scope.$index, scope.row.id)"
            >
              X
            </el-button>
          </template>
        </el-table-column>

        <el-table-column
          label=""
          width="40"
        >
          <template slot="header">
            <el-checkbox
              v-model="allSelected"
              :indeterminate="isIndeterminate"
              @change="toggleSelectAll"
            />
          </template>
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.selected"
              @change="updateSelectedItems"
            />
          </template>
        </el-table-column>
      </el-table>

      <el-alert
        v-if="po_stock_items.length === 0"
        title="No stock items found."
        type="info"
        show-icon
        class="mt-2"
      />
      <br>
      <el-button
        class="right"
        type="success"
        size="small"
        @click="show_add_stock_items_dialog = true"
      >
        <i class="el-icon-plus" />
        ADD NEW ITEM
      </el-button>
    </div>
    <div class="budget-line">
      <p><strong>Total Estimated Budget:</strong> <Money :amount="estimated_value" /></p>
      <p><strong>Total Actual Spent:</strong> <Money :amount="actual_value" /></p>
    </div>

    <el-dialog
      :visible.sync="show_add_stock_items_dialog"
      width="500"
      @opened="set_default_input()"
    >
      <div
        id="stock-template"
        class="field"
      >
        <div class="po-fields">
          <div class="po-field-row">
            <el-select
              v-model="category_supplier_id"
              style="width:100%"
              filterable
              :disabled="po_primary_disabled"
              placeholder="Stock Category"
              size="small"
              @change=" get_stock_items()"
            >
              <el-option
                v-for="category in categories_list"
                :key="category.id"
                :label="category.name"
                :value="category.id"
              />
            </el-select>
            <br>
            <el-select
              v-model="purchase_order.stock_item_branch_id"
              style="width:100%"
              filterable
              :disabled="po_primary_disabled"
              placeholder="Stock Item"
              size="small"
              no-data-text=" Please select a Branch, Supplier, Stock category first. "
              @change="purchase_order.quantity = 1,update_stock_info(true, true)"
            >
              <el-option
                v-for="stock in stock_items_list"
                :key="stock.stock_item_branch_id"
                style="min-width: 300px"
                :label="stock.name_with_specs"
                :value="stock.stock_item_branch_id"
              >
                <span>{{ stock.name }}</span>
                <span style="color: #8492a6;">
                  <small>{{ stock.specs }}</small>
                </span>
              </el-option>
            </el-select>
            <br>
            <label class="po-label">Quantity</label>
            <el-input-number
              v-model="purchase_order.quantity"
              controls-position="right"
              :disabled="po_primary_disabled"
              class="field_style"
              size="small"
              style="width: 210px;"
              @change="update_stock_info(false, true)"
            />
          </div>
          <div class="po-field-row">
            <label class="po-label">Purchase Qty</label>
            <el-input-number
              v-model="purchase_order.purchased_quantity"
              controls-position="right"
              :disabled="po_primary_disabled"
              class="field_style purchased_qty calculation"
              size="small"
              style="width: 210px;"
              @change="update_stock_info(false, false)"
            />
          </div>
          <div class="po-field-row">
            <label class="po-label">Purchase Price</label>

            <el-input-number
              v-if="purchase_order.is_open_quote && purchase_order.unit_price"
              v-model="purchase_order.unit_price"
              controls-position="right"
              :disabled="po_primary_disabled"
              size="small"
              style="width: 210px;"
              @change="update_stock_info(false, false)"
            />

            <el-input-number
              v-else
              v-model="purchase_order.unit_price"
              :disabled="po_primary_disabled"
              controls-position="right"
              size="small"
              style="width: 210px;"
            />
            <div class="inline-stock">
              <p>
                <span>Currently in Stock:</span>
                <label class="calculation">{{ stock_on_hand_desc }}</label>
              </p>

              <el-button
                v-show="purchase_order.mark_as_deleted != 1"
                ref="save_btn"
                size="small"
                type="success"
                @click.prevent="add_stock_item()"
              >
                Add Item
              </el-button>
            </div>
          </div>
        </div>
        <div>
          Link:
          <el-button
            v-if="stock_item_id"
            type="text"
            @click="stock_item_link(stock_item_id)"
          >
            Stock Item
          </el-button>
          <p>
            <span>Min Qty:</span>
            <label
              id="lblMinQty"
              class="calculation"
            >{{ selected_stock_item.minimum_packet_quantity }}</label>
          </p>
          <p>
            <span>Unit Price Calculation:</span>
            <label
              id="lblStockPrice"
              class="calculation"
            >{{ selected_stock_item.stock_price }}</label>
            <label
              class="calculation"
              v-html="stock_price_desc"
            />
          </p>
          <p v-show="Boolean(po_id > 0)">
            <span>Allocated:</span>
            <label class="calculation">{{ allocated_price_desc }}</label>
          </p>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="edit_dialog_visible"
      title="Edit Stock Item"
      width="400px"
      @opened="set_default_input()"
    >
      <div class="edit-field-group">
        <div class="edit-field">
          <label class="po-label">Quantity</label>
          <el-input-number
            v-model="edit_item.quantity"
            size="small"
            style="width: 200px;"
          />
        </div>

        <div class="edit-field">
          <label class="po-label">Purchase Qty</label>
          <el-input-number
            v-model="edit_item.purchased_quantity"
            size="small"
            style="width: 200px;"
          />
        </div>

        <div class="edit-field">
          <label class="po-label">Purchase Price</label>
          <el-input-number
            v-model="edit_item.unit_price"
            size="small"
            style="width: 200px;"
          />
        </div>
      </div>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="small"
          @click="edit_dialog_visible = false"
        >Cancel</el-button>
        <el-button
          type="primary"
          size="small"
          @click="save_edited_item"
        >Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {add_stock_item_to_purchase_order,get_stock_items_for_purchase_order, delete_stock_item_from_purchase_order, create_new_po_with_stock_items} from '../../api/purchase_order_stock_items';
import Money from '../shared/Money.vue';
import {supplier_categories_with_stock_items} from '../../api/stock_items.js';

export default {
  name: 'PoStockItems',
  components: {Money},
  props: {
    po_id:  {
      type: [Number,String],
      required: true},
    supplier_id: {
      type: [Number,String],
      required: true},
    branch_id: {
      type: [Number,String],
      required: true},
    po_primary_disabled: {
      type: Boolean,
      required: true}
  },
  data() {
    return {
      purchase_order: {
        id: 0,
        supplier_id: '',
        proposal_id: '',
        branch_id: '',
        sign_id: '',
        po_status_id: 1,
        is_open_quote: false,
        is_manual: 1,
        description: '',
        actual_value: 0,
        estimated_value: 0,
        charge_percent_applied: 0,
        mark_as_deleted: 0,
      },
      po_transactions: [],
      stock_items_list: [],
      total_amount: 0,
      selected_stock_item: '',
      selected_supplier: '',
      selected_accounts_id: '',
      allocated_price_desc: '',
      stock_price_desc: '',
      stock_on_hand_desc: '',
      convertable_to_stock: false,
      stock_item_id: '',
      po_stock_items: [],
      actual_value: 0,
      estimated_value: 0,
      show_add_stock_items_dialog: false,
      categories_list: [],
      category_supplier_id: '',
      edit_dialog_visible: false,
      edit_item: {
        id: null,
        quantity: 0,
        purchased_quantity: 0,
        unit_price: 0
      },
      allSelected: false,
      selectedItems: []
    };
  },
  computed: {
    isIndeterminate() {
      const selectedCount = this.po_stock_items.filter(item => item.selected).length;
      return selectedCount > 0 && selectedCount < this.po_stock_items.length;
    }
  },
  watch: {
    estimated_value() {
      this.$emit('estimated_value_from_child', this.estimated_value);
    },
    supplier_id: {
      immediate: true,
      handler: async function (newVal) {
        if (!newVal) return;
        const response = await supplier_categories_with_stock_items(this, newVal);
        this.categories_list = response.data;
      }
    }
  },
  created() {
    if(this.po_id > 0) {
      this.get_stock_items_purchase_order();
    }
    this.stock_categories();
  },
  methods: {
    toggleSelectAll() {
      this.po_stock_items.forEach(item => {
        item.selected = this.allSelected;
      });
      this.updateSelectedItems();
    },
    updateSelectedItems() {
      this.selectedItems = this.po_stock_items.filter(item => item.selected);
      this.allSelected = this.selectedItems.length === this.po_stock_items.length;
    },
    assignToNewPo() {
      if (!this.selectedItems.length) return;
      const ids = this.selectedItems.map(item => item.id);
      console.log('Assigning items to new PO:', ids);
      create_new_po_with_stock_items(this, ids, this.po_id).then((response) => {
        this.$message({type: 'success', message: response.data.message});
        const newPoId = response.data.po_id;
        if (newPoId) {
          const url = `/purchase_orders/${newPoId}/edit_new`;
          window.open(url, '_blank');
        }
      });
    },
    add_stock_item(){
      if(this.po_id > 0) {
        const stock_item_data = {
          po_id: this.po_id,
          stock_item_id: this.stock_item_id,
          branch_id: this.branch_id,
          quantity: this.purchase_order.quantity,
          purchased_quantity: this.purchase_order.purchased_quantity,
          unit_price: this.purchase_order.unit_price,
          allocated_price_desc: this.allocated_price_desc
        };
        const stock_item_exists = this.po_stock_items.some(item => item.stock_item_id === this.stock_item_id);

        if (stock_item_exists) {
          this.$message({type: 'warning', message: 'Stock item already added to the purchase order.'});
        } else {
          add_stock_item_to_purchase_order(this, stock_item_data).then((response) => {
            this.$message({type: 'success', message: response.data.message});
            this.get_stock_items_purchase_order();
          });
        }
      }
    },
    open_edit_dialog(row) {
      this.edit_item = {
        id: row.id,
        stock_item_id: row.stock_item_id,
        quantity: row.quantity,
        purchased_quantity: row.purchased_quantity,
        unit_price: row.unit_price
      };

      this.edit_dialog_visible = true;
    },
    save_edited_item() {
      const updated = {
        quantity: this.edit_item.quantity,
        purchased_quantity: this.edit_item.purchased_quantity,
        unit_price: this.edit_item.unit_price,
      };

      if (this.edit_item.id) {
        this.$http
          .patch(`/api/purchase_orders/${this.po_id}/purchase_order_stock_items/${this.edit_item.id}`, updated)
          .then((response) => {
            this.$message({ type: 'success', message: response.data.message });
            this.get_stock_items_purchase_order();
            //this.update_stock_info(false, false);
            this.edit_dialog_visible = false;
          });
      }
    },
    get_stock_items_purchase_order() {
      get_stock_items_for_purchase_order(this, this.po_id).then((response) => {
        this.po_stock_items = response.data.stock_items.map(item => ({
          ...item,
          selected: false
        }));
        this.actual_value = response.data.actual_value;
        this.estimated_value = response.data.estimated_value;
        this.allSelected = false;
        this.selectedItems = [];
      });
    },
    delete_stock_item_from_purchase_order(index, id){
      delete_stock_item_from_purchase_order(this, id).then((response)=> {
        this.po_stock_items.splice(index, 1);
        this.get_stock_items_purchase_order();
        this.$message({ type: 'success', message: response.data.message });
      });
    },
    async stock_categories() {
      await supplier_categories_with_stock_items(this, this.supplier_id).then((response)=> {
        this.categories_list = response.data;
      }
      );
    },
    get_stock_items() {
      if ( this.supplier_id == undefined || this.category_supplier_id == undefined) return;
      this.stock_items_list = [];

      let params = {
        supplier_id: this.supplier_id,
        category_supplier_id: this.category_supplier_id,
        branch_id: this.branch_id,
      };

      this.$http.post('/get_stock_items_by_params/', params).then(
        function (response) {
          this.stock_items_list = response.data;
        }
      );
    },
    stock_item_link(stock_item_id) {
      window.open(`/stock_items/${stock_item_id}/edit`, '_blank');
    },
    update_po_approved_date() {
      let approved_po = self.po_transactions.filter(
        (item) => item.po_status == 'APPROVED'
      )[0];
      this.update_po_trans_date(approved_po.id, this.po_approved_date);
    },
    update_po_received_date() {
      let received_po = self.po_transactions.filter(
        (item) => item.po_status == 'RECEIVED'
      )[0];
      this.update_po_trans_date(received_po.id, this.po_received_date);
    },
    round(num) {
      return +(Math.round(num + 'e+3') + 'e-3');
    },
    update_actual_value() {
      this.purchase_order.actual_value = this.purchase_order.estimated_value;
    },
    stock_specs(stock) {
      return `Width: ${stock.width} , Height: ${stock.height}, GSM: ${stock.thickness}`;
    },
    update_stock_info(is_price_locked, is_purchase_qty_locked) {
      if (parseInt(this.purchase_order.po_status_id) !== 1) return;

      const stock = this.stock_items_list.find(
        s => s.stock_item_branch_id == this.purchase_order.stock_item_branch_id
      );

      this.selected_stock_item = stock;
      if (!stock) return;

      const result = this.calculate_price(
        stock,
        this.purchase_order.quantity
      );

      // Apply calculated values
      if (is_purchase_qty_locked)
        this.purchase_order.purchased_quantity = result.purchase_qty;

      if (is_price_locked)
        this.purchase_order.unit_price = result.unit_price;

      this.stock_price_desc = result.desc;

      // Totals
      this.purchase_order.estimated_value = result.total;
      this.purchase_order.actual_value = result.total;

      // Stock levels
      this.stock_on_hand_desc =
          Number(stock.stock_on_hand) + Number(this.purchase_order.purchased_quantity);

      if (this.purchase_order.proposal_id !== undefined) {
        this.allocated_price_desc =
            Number(stock.allocated) + Number(this.purchase_order.quantity);
      }

      // Keep stock_item_id synced
      this.stock_item_id = stock.id;
    },
    calculate_price(stock, quantity) {
      if (!stock) return {
        purchase_qty: 0,
        unit_price: 0,
        total: 0,
        desc: 'No stock selected.'
      };

      const qty = Number(quantity) || 1;
      const price = Number(stock.price) || 0;
      const unit = Number(stock.unit);

      let purchase_qty = qty;
      let unit_price = price;
      let desc = '';

      // --- Case 1: PACKET QUANTITY ----------------------------------
      if (stock.minimum_packet_quantity && stock.minimum_packet_quantity > 0) {

        purchase_qty =
            Math.ceil(qty / stock.minimum_packet_quantity) *
            stock.minimum_packet_quantity;

        if (!unit || isNaN(unit)) {
          unit_price = 0;
          desc = 'Invalid stock unit — cannot calculate unit price.';
        } else {
          unit_price = +(price / unit).toFixed(3);
          desc = `${unit_price} NZD per item (${price} / ${unit})`;
        }

      } else {

        // --- Case 2: STANDARD ITEM ------------------------------------
        unit_price = price;
        desc = `${price} NZD each`;
      }

      return {
        purchase_qty,
        unit_price,
        total: +(purchase_qty * unit_price).toFixed(2),
        desc
      };
    },
    format_number(value) {
      const num = Number(value);
      if (isNaN(num)) return '-';
      return Number.isInteger(num) ? num : num.toFixed(2);
    },
    set_default_input() {
      Array.from(document.querySelectorAll('.el-input__inner')).forEach(
        function (e) {
          e.classList.add('browser-default');
          if (e.querySelector('input') != null)
            e.querySelector('input').className += ' browser-default';
        }
      );
    }
  },
};
</script>

<style scoped>
.po-field-row {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
}

.po-label {
  font-weight: bold;
  margin-bottom: 4px;
}
.edit-field-group {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.edit-field {
  display: flex;
  flex-direction: column;
}

.budget-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 33px 10px;
}

.inline-stock {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.calculation {
  font-size: 14px; ; color: black;
}

.padding-left{
  padding-left: 10px;
}

td, th {
  padding: 6px;
}

#stock-template .el-input__inner{
  width: 450px;
}

#stock-table{min-width: 800px;}
</style>
